import { Component, OnInit, ViewChild } from '@angular/core';
import { EventNavbarService } from 'src/app/services/event-navbar.service';
import { NavigationService } from '../../services/navigation.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
    selector: 'app-dashboard-contratista',
    templateUrl: './dashboard-contratista.component.html',
    styleUrls: ['./dashboard-contratista.component.scss']
  })

export class DashboardContratistaComponent implements OnInit{
    loginData = JSON.parse(sessionStorage.getItem('loginData'));
    listaCapacitacionesRealizadas : [] = [];
    listaCapacitacionesMes : [] = [];
    listaCapacitacionesNoRealizadas : [] = [];
    pageActualRealizadas : number = 1;
    pageActualPendientes : number = 1;
    pageActualNoRealizadas : number = 1;

    constructor(private navigationService: NavigationService,
        private eventNavbarService: EventNavbarService,
        private dashboardService : DashboardService) { }

    ngOnInit() {

      if (sessionStorage.getItem('logout') === 'true' || sessionStorage.getItem('logout') === null) {
        sessionStorage.setItem('logout', 'false');
        location.reload();
      } else{
        $("#show-loading").css('display', 'grid')

        this.openNavbar();
        this.findCapacitacionesRealizadas();
        this.findCapacitacionesMes();
        this.findCapacitacionesNoRealizadas();
        
      }

        if (!this.navigationService.getValidLogin()) { this.navigationService.goTo('/login'); }
    }

    openNavbar() {
        this.eventNavbarService.openNavbar();
    }

    findCapacitacionesRealizadas(){
        this.dashboardService.getListaCapacitacionesRealizadas(parseInt(sessionStorage.getItem('userid')))
        .then(response => {
          this.listaCapacitacionesRealizadas = response;
        })
        .catch(error => {
          console.log(error);
        });
    }

    findCapacitacionesMes(){
        this.dashboardService.getListaCapacitacionesMes(parseInt(sessionStorage.getItem('userid')))
        .then(response => {
          this.listaCapacitacionesMes = response;
        })
        .catch(error => {
          console.log(error);
        });
    }

    findCapacitacionesNoRealizadas(){
      console.log("this.loginData");
      console.log(parseInt(sessionStorage.getItem('userid')));
        this.dashboardService.getListaCapacitacionesNoRealizadas(parseInt(sessionStorage.getItem('userid')))
        .then(response => {
          this.listaCapacitacionesNoRealizadas = response;

          $("#show-loading").css('display', 'none')
        })
        .catch(error => {
          console.log(error);
          $("#show-loading").css('display', 'none')
        });
    }
}
